import React from "react";
import { __ } from "services/Translator";

const signupBanner = require("assets/play365/images/lognReg/signup-banner.webp");

export function AuthMobileWelcomeOffer() {
  return (
    <div className="auth-welcome-promo auth-welcome-promo--mobile">
      <img
        className="auth-welcome-promo__banner"
        alt=""
        src={signupBanner}
      />
      <span className="auth-welcome-promo__mobile-title">
        {__("Welcome")}
        <br />
        {__("bonus!")}
      </span>
      <div className="auth-welcome-promo__mobile-foot">
        <span className="auth-welcome-promo__copy">
          {__("Claim your welcome bonus when you join.")}
        </span>
      </div>
      <img
        className="auth-welcome-promo__diamond auth-welcome-promo__diamond--bottom"
        alt=""
        src={require("assets/play365/images/cashierModal/diamond-2.webp")}
      />
    </div>
  );
}

export function AuthBottomWelcomePromo({ variant = "default" }) {
  if (variant === "betmode") {
    return (
      <div className="betmode-auth__promo">
        <img className="betmode-auth__promo-art" alt="" src={signupBanner} />
        <div className="betmode-auth__promo-content">
          <h3 className="betmode-auth__promo-title">
            {__("Welcome")}
            <br />
            {__("bonus!")}
          </h3>
          <p className="betmode-auth__promo-copy">
            {__("Claim your welcome bonus when you join.")}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-welcome-promo auth-welcome-promo--bottom">
      <img className="auth-welcome-promo__art" alt="" src={signupBanner} />
      <div className="auth-welcome-promo__body">
        <div className="auth-welcome-promo__heading">
          {__("Welcome")}
          <br />
          {__("bonus!")}
        </div>
        <p className="auth-welcome-promo__copy">
          {__("Claim your welcome bonus when you join.")}
        </p>
      </div>
    </div>
  );
}
